//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[["origin","alignmentVector","rotationVector","rotationObject","clockAngle"],"CreateFixturePortWithRotationByAbsPosition",{R_:{fixturePort:"Routing.FixturePort"}},5,0],[["origin","alignmentVector"],"CreateFixturePortNoRotationByAbsPosition",{R_:{fixturePort:"Routing.FixturePort"}},2,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","point"],"CreateFixturePortWithRotationByPoint",{R_:{fixturePort:"Routing.FixturePort"}},6,0],[["origin","alignmentVector","point"],"CreateFixturePortNoRotationByPoint",{R_:{fixturePort:"Routing.FixturePort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","axis"],"CreateFixturePortWithRotationOnAxis",{R_:{fixturePort:"Routing.FixturePort"}},6,0],[["origin","alignmentVector","derivationObject"],"CreateFixturePortNoRotationOnAxis",{R_:{fixturePort:"Routing.FixturePort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","allowMultipleConnections"],"CreateFixturePortWithRotationByAbsPosition1",{R_:{fixturePort:"Routing.FixturePort"}},6,0],[["origin","alignmentVector","allowMultipleConnections"],"CreateFixturePortNoRotationByAbsPosition1",{R_:{fixturePort:"Routing.FixturePort"}},3,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","point","allowMultipleConnections"],"CreateFixturePortWithRotationByPoint1",{R_:{fixturePort:"Routing.FixturePort"}},7,0],[["origin","alignmentVector","point","allowMultipleConnections"],"CreateFixturePortNoRotationByPoint1",{R_:{fixturePort:"Routing.FixturePort"}},4,0],[["origin","alignmentVector","rotationVector","rotationObject","clockAngle","axis","allowMultipleConnections"],"CreateFixturePortWithRotationOnAxis1",{R_:{fixturePort:"Routing.FixturePort"}},7,0],[["origin","alignmentVector","derivationObject","allowMultipleConnections"],"CreateFixturePortNoRotationOnAxis1",{R_:{fixturePort:"Routing.FixturePort"}},4,0],[["axis"],"CreateFromAxis",{R_:{fixturePort:"Routing.FixturePort"}},1,0],[["csys","createRotationVector"],"CreateFromCsys",{R_:{fixturePort:"Routing.FixturePort"}},2,0]],[]];
SPLM.Routing.FixturePortCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Routing.FixturePortCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;